<script setup>
import { ref, onMounted } from 'vue';
import { Head } from '@inertiajs/vue3';
import axios from 'axios';

const items = ref([]);
const loading = ref(true);

const loadData = async () => {
    loading.value = true;
    try {
        const response = await axios.get('/admin/seo-meta-checker/data');
        if (response.data.status === 'success') {
            items.value = response.data.data;
        }
    } catch (error) {
        console.error('Error:', error);
    } finally {
        loading.value = false;
    }
};

const getStatusColor = (status) => {
    return status === 'OK' ? 'success' : 'danger';
};

const getStatusIcon = (status) => {
    return status === 'OK' ? 'fa fa-check-circle' : 'fa fa-exclamation-circle';
};

onMounted(() => {
    loadData();
});
</script>

<template>
    <Head title="SEO Meta Checker" />

    <div class="container-full">
        <div class="content-header">
            <div class="d-flex align-items-center">
                <div class="me-auto">
                    <h3 class="page-title">SEO Meta Checker</h3>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/admin/dashboard"><i class="mdi mdi-home-outline"></i></a></li>
                            <li class="breadcrumb-item active">SEO Meta Checker</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>

        <section class="content">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-title">Status Meta Data Website</h4>
                            <div class="card-controls">
                                <button class="btn btn-sm btn-outline-primary" @click="loadData">
                                    <i class="fa fa-refresh" :class="{ 'fa-spin': loading }"></i> Refresh
                                </button>
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Type</th>
                                            <th>Title</th>
                                            <th>Meta Title</th>
                                            <th>Meta Description</th>
                                            <th>Meta Keywords</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="loading">
                                            <td colspan="7" class="text-center p-5">
                                                <div class="spinner-border text-primary"></div>
                                            </td>
                                        </tr>
                                        <tr v-else-if="items.length === 0">
                                            <td colspan="7" class="text-center p-5">Tidak ada data</td>
                                        </tr>
                                        <tr v-else v-for="(item, index) in items" :key="index">
                                            <td>{{ index + 1 }}</td>
                                            <td><span class="badge badge-info">{{ item.type }}</span></td>
                                            <td>{{ item.title }}</td>
                                            <td>
                                                <span :class="'text-' + (item.has_meta_title ? 'success' : 'danger')" :title="item.meta_title">
                                                    <i :class="item.has_meta_title ? 'fa fa-check' : 'fa fa-times'"></i>
                                                </span>
                                            </td>
                                            <td>
                                                <span :class="'text-' + (item.has_meta_description ? 'success' : 'danger')" :title="item.meta_description">
                                                    <i :class="item.has_meta_description ? 'fa fa-check' : 'fa fa-times'"></i>
                                                </span>
                                            </td>
                                            <td>
                                                <span :class="'text-' + (item.has_meta_keywords ? 'success' : 'danger')" :title="item.meta_keywords">
                                                    <i :class="item.has_meta_keywords ? 'fa fa-check' : 'fa fa-times'"></i>
                                                </span>
                                            </td>
                                            <td>
                                                <span :class="'badge badge-' + getStatusColor(item.status)">
                                                    {{ item.status }}
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
